import React from "react"
import { RouteComponentProps } from "@reach/router"
import { setLocale } from "../i18n"

export interface LocalizedPageProps extends RouteComponentProps {
  locale: string;
  id?: string;
}

const withLocale = (WrappedComponent: React.FC<LocalizedPageProps>) => (props: Partial<LocalizedPageProps>) => {
  const locale = props.locale || "et"
  setLocale(locale)

  return <WrappedComponent {...props} locale={locale}/>
}

export default withLocale
